import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import { change_testimonials_status, create_testimonials, delete_testimonials, get_testimonials, update_testimonials } from '../../utils/api-routes';
import Swal from "sweetalert2";

function* getTestimonials() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_testimonials}`);
        console.log("Get Testimonials Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_TESTIMONIALS, payload: data?.data });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Testimonials Saga Error ::: ", error)
    }
}

function* createTestimonials(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_testimonials}`, payload?.data);
        console.log("Create Testimonials Saga Response ::: ", data)

        if (data?.result) {
            Swal.fire({
                icon: "success",
                title: "Testimonials Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Testimonials',
            text: "Failed To Create Testimonials",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Testimonials Saga Error ::: ", error?.response?.data)
    }
}

function* updateTestimonials(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_testimonials}`, payload?.data);
        console.log("Update Testimonials Saga Response ::: ", data)

        if (data?.result) {
            Swal.fire({
                icon: "success",
                title: "Testimonials Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_TESTIMONIALS, payload: null })
        }

    } catch (error) {
        console.log("Update Testimonials Saga Error ::: ", error?.response?.data)
    }
}

function* deleteTestimonials(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_testimonials}`, payload);
            console.log("Delete Testimonials Saga Response ::: ", data)
            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: "Testimonials Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_TESTIMONIALS, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete Testimonials",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Testimonials Saga Error ::: ", error?.response?.data)
    }
}

function* changeTestimonialsStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_testimonials_status}`, payload);
            console.log("Change Testimonials Status Saga Response ::: ", data)

            if (data.result) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_TESTIMONIALS, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Testimonials Status Saga Error ::: ", error?.response?.data)
    }
}

export default function* testimonialsSaga() {
    yield takeLeading(actionTypes?.GET_TESTIMONIALS, getTestimonials);
    yield takeLeading(actionTypes?.CREATE_TESTIMONIALS, createTestimonials);
    yield takeLeading(actionTypes?.UPDATE_TESTIMONIALS, updateTestimonials);
    yield takeLeading(actionTypes?.DELETE_TESTIMONIALS, deleteTestimonials);
    yield takeLeading(actionTypes?.CHANGE_TESTIMONIALS_STATUS, changeTestimonialsStatus);
}
